import { useCallback, useState } from "react";
import { downloadFileWithoutInstance } from "../common/services";
import { useToaster } from "../common/contexts/toast";
import { errorMessageOf } from "../utils";

/**
 * Download one document: a plain URL opens directly, an S3 file gets a signed URL
 * first; either way it opens in a new tab. Shared by doc rows and the doc viewer panel.
 *
 * @returns {{ downloadDoc: Function, isDownloading: boolean }}
 */
const useDocDownload = () => {
    const { showToaster } = useToaster();
    const [isDownloading, setIsDownloading] = useState(false);

    const downloadDoc = useCallback(async (doc) => {
        if (isDownloading) return;
        setIsDownloading(true);
        try {
            await downloadFileWithoutInstance(doc?.file);
        } catch (error) {
            showToaster && showToaster("doc-download-error", errorMessageOf(error, "Couldn't download the file."), false);
        } finally {
            setIsDownloading(false);
        }
    }, [isDownloading, showToaster]);

    return { downloadDoc, isDownloading };
};

export default useDocDownload;
